import React from 'react';
import renderHTML from 'react-render-html';
import RadioButton from '../radio-button/radio-button';
import FormLabel from '../../../../components/form/label/label';
import './ssm-radio-button.css';

const SSMRadioButton = (props) => {
  const { radioButtonId, radioButtonLabel, radioButtonDesc,
    radioButtonChecked, onRadioButtonCallBackActionWithToggle } = props;

  return (
    <div>
      <RadioButton
        id={radioButtonId}
        iconType="tick"
        checked={radioButtonChecked}
        callBackAction={onRadioButtonCallBackActionWithToggle}
      />
      <div className="text-section">
        <FormLabel label={radioButtonLabel} forId={radioButtonId} />
        {radioButtonDesc && <p id="main-description" className="radio-button-description">{renderHTML(radioButtonDesc)}</p>}
      </div>
    </div>
  );
};


export default SSMRadioButton;
